module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/ZOOPLA_PEAK2_2767-93820b6688133b877b88fc0af688e661.jpg";